import isAuthorized from './isAuthorized';
import isAdmin from './isAdmin';
import isDirector from './isDirector';
import isUpperManagement from './isUpperManagement';
import isEducationDirectorAdminAssistant from './isEducationDirectorAdminAssistant';
import isHRUser from './isHRUser';

export const canViewPerformanceManagement = (user: any) =>
  !!user?.roles?.includes('admin') ||
  isAuthorized({ moduleName: 'PerformanceManagement', functionName: 'List' }, user) ||
  isAuthorized({ moduleName: 'PerformanceManagement', functionName: 'Show' }, user);

export const canCreateAnyPerformanceDocument = (user: any) =>
  !!user?.roles?.includes('admin') ||
  isAuthorized({ moduleName: 'PerformanceFeedback', functionName: 'Create' }, user) ||
  isAuthorized({ moduleName: 'PerformanceOneOnOne', functionName: 'Create' }, user) ||
  isAuthorized({ moduleName: 'PerformanceImprovement', functionName: 'Create' }, user) ||
  isAuthorized({ moduleName: 'PerformanceVerbalWarning', functionName: 'Create' }, user) ||
  isAuthorized({ moduleName: 'PerformanceDisciplinaryAction', functionName: 'Create' }, user);

export const canUpdatePerformanceModule = (moduleName: string, user: any) =>
  isAuthorized({ moduleName, functionName: 'Update' }, user) ||
  isAuthorized({ moduleName, functionName: 'Edit' }, user);

export const canDeletePerformanceManagement = (user: any) =>
  isAdmin(user) ||
  isDirector(user) ||
  isEducationDirectorAdminAssistant(user) ||
  isUpperManagement(user) ||
  isHRUser(user) ||
  !!user?.roles?.includes('franchisee');
